<ion-spinner></ion-spinner>
<div>{{message}}</div>